import {
    TEMPLATE_MEDIA,
    TEMPLATE_SOURCE,
    TEMPLATE_STATUS,
} from './unlayer.constants';

export const DEFAULT_HTML_BODY = '<html><body></body></html>';

export function mapTemplateToSitePage(template) {
    const {
        id,
        html,
        groupOrder,
        title,
        alias,
        templateGroupId: siteId,
        deleted: isDeleted,
        builderJson: {
            content: design,
            options,
        } = {},
        builderJson,
        templateMedia,
        templateSource,
        templateStatus,
        ...others
    } = template;


    const { seoDescription, chunks } = getBuilderOptions({ options });

    return {
        id,
        title,
        alias,
        siteId,
        isDeleted: isDeleted ?? false,
        content: {
            chunks,
            design,
            html: html ?? DEFAULT_HTML_BODY,
        },
        groupOrder,
        seoDescription,
        builderJson,
        templateSource,
        templateMedia,
        templateStatus,
        ...others,
    };
}

export function mapSiteInputToGroupCreate(site) {
    const {
        title,
        builderJson,
        templates = [],
        alias,
        status,
        html,
    } = site;

    return {
        title,
        alias,
        html,
        builderJson: builderJson ?? {
            content: {},
            options: {},
        },
        templateGroupStatus: status,
        templates: templates.map((page) => mapCreatePageToTemplateCreate(page, site.id)),
        templateMedia: TEMPLATE_MEDIA.Web,
    };
}

export function mapCreatePageToTemplateCreate(input, siteId) {
    const {
        builderJson,
        title,
        alias,
        html,
        groupOrder,
    } = input;

    return {
        title,
        alias,
        groupOrder: groupOrder ?? 0,
        html: html ?? DEFAULT_HTML_BODY,
        templateGroupId: siteId,
        templateMedia: TEMPLATE_MEDIA.Web,
        templateStatus: TEMPLATE_STATUS.Draft,
        builderJson: builderJson || { html: DEFAULT_HTML_BODY, content: {}, options: {} },
        templateSource: TEMPLATE_SOURCE.unlayer,
    };
}

export function getBuilderOptions({ options } = {}) {
    return (options ?? {});
}
